// import { children } from 'cheerio/lib/api/traversing'
import React from 'react'

const FlexStart = ({children}) => {
  return (
    <div className='ls-flex-start'>{children}</div>
  )
}

export default FlexStart